import React from "react";

const InvalidEmptyCalendarCell = () => (
  <div className="h-14 w-16 text-miru-dark-purple-1000 xl:w-24" />
);

export default InvalidEmptyCalendarCell;
